import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { loadAction } from "./actions";

const ui = createSlice({
  name: "ui",
  initialState: {
    activeId: "",
    metadataExpanded: true,
    advancedExpanded: false,
  },
  reducers: {
    metadataExpandedToggled: (state) => ({
      ...state,
      metadataExpanded: !state.metadataExpanded,
    }),
    advancedExpandedToggled: (state) => ({
      ...state,
      advancedExpanded: !state.advancedExpanded,
    }),
    setActiveId: (state, index: PayloadAction<string>) => ({
      ...state,
      activeId: index.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(loadAction, (state, action) => ({
      ...state,
      activeId: action.payload.fibonaccis.ids[0] as string,
    }));
  },
});

export default ui;
